import { AxiosError } from "axios";

import { api } from "@/lib/axios";

interface FetchProductsParams {
	name: string;
	type: string;
	niche: string;
	platform: string;
	sortBy: "created_at" | "commission_value" | "sales";
	perPage: number;
}

export type Product = {
	id: string;
	name: string;
	type: {
		name: string;
	};
	image: string;
};

export async function fetchProducts(
	params: Partial<FetchProductsParams>,
): Promise<
	| {
			status: "success";
			data: Product[];
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		const { data } = await api.get("/product", {
			params,
		});

		return {
			status: "success",
			data: data.data.data,
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
